module.exports = jsmodule["react"];